<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-card>
      <div>
        <md-toolbar class="subtitulos">
          <h3>Diagnóstico</h3>
        </md-toolbar>
      </div>
      <div class="diagnosticoBody parrafos">
        <div class="rowFlx">
          <div class="div100 alignLeft">
            <div class="divFlexStart justifySpace">
              <div class="divItemDos">
                <b-form-group
                  id="example-datepicker"
                  label="Fecha"
                  label-for="example-datepicker"
                  class="bold"
                >
                  <b-form-datepicker
                    id="example-datepicker"
                    v-model="date"
                    label-no-date-selected="Fecha"
                    label-help="Ingresa la fecha"
                    disabled
                  ></b-form-datepicker>
                </b-form-group>
              </div>
              <div class="divItemDos">
                <b-form-group label="Clínica" class="bold">
                  <b-form-input
                    v-model="clinicSelected"
                    placeholder="Clínica"
                    class="selectCustom"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="divFlexStart justifySpace">
              <div class="divItemDos alignItemTres">
                <b-form-group label="Paciente" class="bold">
                  <b-form-input
                    v-model="patComplete"
                    placeholder="Paciente"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="divItemCuatro alignItemTres">
                <b-form-group label="ID" class="bold">
                  <b-form-input
                    v-model="patId"
                    placeholder="ID"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="divItemCuatro alignItemTres">
                <b-form-group label="Edad" class="bold">
                  <b-form-input
                    v-model="PatYears"
                    type="number"
                    placeholder="Edad"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="divFlexStart justifySpace">
              <div class="divItemDos alignItemTres">
                <b-form-group label="OG" class="bold">
                  <b-form-input
                    v-model="doctorSelected"
                    class="selectCustom"
                    placeholder="Doctor"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="divItemCuatro alignItemTres">
                <b-form-group label="Nivel de PTI" class="bold">
                  <b-form-input
                    v-model="nivelPti"
                    placeholder="Nivel de PTI"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>

            <div class="divItemUno alignItemTres">
              <b-form-group label="Condición sistémica" class="bold">
                <b-form-input
                  v-model="enfermedad"
                  placeholder="Condición sistémica"
                  disabled
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="divFlexStart justifySpace">
              <div class="divItemUno">
                <p class="bold">
                  Información relevante sobre tu paciente (medicamentos, tratamientos realizados recientemente)
                </p>
                <b-form-textarea
                  v-model="observacion"
                  placeholder="Alineación del paciente"
                  rows="3"
                  max-rows="6"
                  disabled
                ></b-form-textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "diagnosisForm",
  props: {
    date: {
      type: String,
      required: true,
    },
    clinicSelected: {
      type: String,
      required: true,
    },
    patComplete: {
      type: String,
      required: true,
    },
    doctorSelected: {
      type: String,
      required: true,
    },
    patId: {
      type: Number,
      required: true,
    },
    PatYears: {
      type: Number,
      required: true,
    },
    enfermedad: {
      type: String,
      required: true,
    },
    observacion: {
      type: String,
      required: true,
    },
    candidato: {
      type: Boolean,
      required: true,
    },
    nivelPti: {
      type: Number,
    },
    idEstatus: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
    };
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {},
  destroyed() {},
  methods: {
    check(e) {
      this.$nextTick(() => {
        this.$emit("changeOrtodoncia", e);
        this.$forceUpdate();
      });
    },
  },
};
</script>
<style scoped>
.alignItemTres {
  text-align: left !important;
}

.diagnosticoBody {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
}

.rowFlx {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
}

.div100 {
  width: 100%;
}

.alignLeft {
  display: flex;
  text-align: left;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-left: 15px;
}

.justifySpace {
  justify-content: space-around !important;
  margin-top: 10px;
}

.selectCustom {
  font-size: 1rem !important;
}
</style>
